import React from "react";
import { Stack } from "@mui/material";

import { WovoText } from "components/logos/wovo-text";
import { WovoLogo } from "components/logos/wovo-logo";

export function SidebarHeader() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ height: "70px", pl: 2, py: 1.375 }}
    >
      <WovoLogo size={40} />
      <WovoText height={18} />
    </Stack>
  );
}
